<template>
    <v-card color="rgba(170,170,170,0.4)" class="" height="380" width="100%" style="overflow-y: auto">
        <v-card-title>
            {{clas.dados.nome}}
        </v-card-title>
        <v-card-subtitle>
            {{clas.dados.email}}<br />
            {{clas.dados.grauAtual}}º grau - {{clas.dados.claAtual}}
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
            <v-data-table hide-default-footer fixed-header :items="clas.clas" :headers="fields" :items-per-page="10">
                <template v-slot:item.data="{ item }">
					{{mostrarData(item.data)}}
				</template>
                <template v-slot:item.actions="{ item }">
                    <v-btn :disabled="item.ordenacao == 1" text color="primary" @click="editar(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn :disabled="item.ordenacao == 1" text color="primary" @click="excluir(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    //import Modal from '@/components/geral/Modal'
    //import { baseApiUrl, showError, showSuccess } from "@/config/global"
    //import axios from 'axios'
    import metodos from '@/mixins/metodos'
    import Br from '@/config/barramento'

	export default{
        props:['clas'],
        computed:{
            clasFiltrados(){
                return this.clas.clas.filter((i) => {
                    i.data = this.mostrarData(i.data)
                })
            }
        },
        components:{
            //Modal
            },
        mixins: [metodos],
		data(){
			return {
                showModal: false,
                registro: {},
                totalPaginas: null,
                itensPorPagina: 5,
                paginaAtual: 1,
				fields: [
                    {text: 'Clã', value: 'cla', align: 'center', divider: true},
					{text: 'Data', value: 'data', align: 'center', divider: true},
					{text: 'Ações', value: 'actions', align: 'center', divider: true},
                ],
            }
        },
        methods:{
            chamaModal(registro){
                this.registro = registro
                this.showModal = true
            },
            close(){
                this.showModal = false
            },
            editar(cla){
                Br.setEditarHistoricoCla(cla)
            },

            excluir(cla){
                Br.setExcluirHistoricoCla(cla)
            }

            

        },

        created(){
            
        }
	}
</script>

<style scoped>
	.clas th, .clas tr{
		text-align: center;
	}
</style>